// Enhanced EU/UK redirect with full-site coverage
(function () {
  const isInIframe = window.self !== window.top;

  const urlParams = new URLSearchParams(window.location.search);
  const adminPreview = urlParams.get("preview");
  const devAccess = urlParams.get("dev");
  const noRedirect = urlParams.get("no-redirect");

  const isAdminSession = sessionStorage.getItem("isAdminSession") === "true";
  const isDevSession = sessionStorage.getItem("isDevSession") === "true";
  const devBypassEnabled = localStorage.getItem("dev-bypass") === "true";

  const referrer = document.referrer || "";
  const isShopifyReferrer =
    referrer.includes(".shopify.com") ||
    referrer.includes("admin.shopify") ||
    referrer.includes("partners.shopify");

  const hostname = window.location.hostname;
  const isShopifyDomain =
    hostname.includes(".shopify.com") ||
    hostname.includes("shopify.dev") ||
    hostname.includes("shopifypreview.com");

  const userAgent = navigator.userAgent || "";
  const isShopifyUserAgent =
    userAgent.includes("ShopifyMobile") || userAgent.includes("Shopify");

  if (adminPreview === "admin" || adminPreview === "true" || isInIframe) {
    sessionStorage.setItem("isAdminSession", "true");
  }

  if (
    devAccess === "true" ||
    devAccess === "allow" ||
    devAccess === "treegers2024"
  ) {
    sessionStorage.setItem("isDevSession", "true");
    localStorage.setItem("dev-bypass", "true");
  }

  if (noRedirect === "true" || noRedirect === "1") {
    localStorage.setItem("dev-bypass", "true");
  }

  const euUkCountries = [
    "AT","BE","BG","CY","CZ","DE","DK","EE","ES","FI",
    "FR","GR","HR","HU","IE","IT","LT","LU","LV","MT",
    "NL","PL","PT","RO","SE","SI","SK","GB","TR"
  ];

  const hasBypass =
    isInIframe ||
    isShopifyReferrer ||
    isShopifyDomain ||
    isShopifyUserAgent ||
    isAdminSession ||
    isDevSession ||
    devBypassEnabled ||
    adminPreview === "admin" ||
    adminPreview === "true" ||
    devAccess === "true" ||
    devAccess === "allow" ||
    devAccess === "treegers2024" ||
    noRedirect === "true" ||
    noRedirect === "1" ||
    localStorage.getItem("eu-redirect") === "disabled";

  const shouldRedirect = !hasBypass;

  window.treegers = window.treegers || {};
  window.treegers.redirect = {
    enableDevAccess: function () {
      sessionStorage.setItem("isDevSession", "true");
      localStorage.setItem("dev-bypass", "true");
      console.log("Dev access enabled");
    },
    disableDevAccess: function () {
      sessionStorage.removeItem("isDevSession");
      localStorage.removeItem("dev-bypass");
      console.log("Dev access disabled");
    },
    disableEURedirect: function () {
      localStorage.setItem("eu-redirect", "disabled");
      console.log("EU/UK redirect disabled");
    },
    enableEURedirect: function () {
      localStorage.removeItem("eu-redirect");
      console.log("EU/UK redirect enabled");
    },
    checkStatus: function () {
      const status = {
        shouldRedirect,
        hasBypass,
        isInIframe,
        devBypass: localStorage.getItem("dev-bypass"),
        euRedirectDisabled: localStorage.getItem("eu-redirect") === "disabled",
      };
      console.table(status);
      return status;
    },
  };

  if (!shouldRedirect) return;

  setTimeout(function () {
    // IMPORTANT: redirect only on positive EU/UK match
    fetch("https://ipapi.co/json/")
      .then((response) => {
        if (!response.ok) throw new Error("Geolocation service unavailable");
        return response.json();
      })
      .then((data) => {
        const countryCode = data.country_code || data.country;
        const currentPath = window.location.pathname + window.location.search;

        const stillShouldRedirect = !hasBypass && window.self === window.top;

        if (stillShouldRedirect && euUkCountries.includes(countryCode)) {
          console.log(`Redirecting ${countryCode} visitor to EU site`);
          window.location.href = `https://eu.treegers.com${currentPath}`;
        } else {
          // explicitly do nothing
          // console.log(`No redirect for country: ${countryCode}`);
        }
      })
      .catch((error) => {
        // SAFEST fallback: do not redirect if geo lookup fails
        console.warn("Geolocation check failed (no redirect):", error);
      });
  }, 100);
})();
